import React from 'react';
import { Table } from 'reactstrap';

import Rank from './Rank';

function TableRank({ users }) {
  return (
    <Table dark striped size="sm" hover className="mb-3">
      <thead>
        <tr>
          <td className="letter-spacing">Rank</td>
          <td className="letter-spacing">Pseudo</td>
          <td className="letter-spacing">Score</td>
          <td className="letter-spacing">Team</td>
        </tr>
      </thead>
      <tbody>
        {users.map((user, i) => {
          return <Rank {...user} key={user.uuid} ranking={i + 1} />;
        })}
      </tbody>
    </Table>
  );
}

export default TableRank;
